// Import additional JS modules specific to assets/js
import "./ics.js";
import "./booking.js";
import "./flatpickr-init-app.js";
import initFilterOffcanvas from "./filter-offcanvas.js";
import GemengAppModule from './gemengApp/index.js';
import { initBookingValidationLink } from './gemengApp/shared/utils.js';

// Initialize modules on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  // Initialize GemengApp modules (Hall Booking, Appointments, POI, etc.)
  GemengAppModule.createIfNeeded();

  // Initialize filter offcanvas handler
  initFilterOffcanvas();

  // Initialize booking validation link (for thank you pages)
  initBookingValidationLink();
});
